<template>
  <div class="quote-item"
       :class="classes">
    <div class="row no-padding">
      <div class="col-md-4 no-padding quote-item__summary">
        <div class="quote-item__heading">
          #{{ quote.reference }}
        </div>
        <div class="quote-item__sub-heading">
          Date raised: {{ formatDate(quote.date) }}
        </div>
        <div v-if="quote.salesPerson"
             class="quote-item__sub-heading">
          Raised by: {{ quote.salesPerson }}
        </div>
        <div v-if="quote.person"
             class="quote-item__sub-heading">
          Raised on behalf of: {{ quote.person }}
        </div>
        <div class="quote-item__cost">
          Total cost (ex. vat): {{ formatPrice(quote.totalExcludingVat) }}
        </div>
        <div class="quote-item__cost">
          Total cost (inc. vat): {{ formatPrice(quote.totalIncludingVat) }}
        </div>
        <div v-if="quote.statusId === 'ACT'"
             class="quote-item__convert">
          <button class="btn btn-sm btn-accent-1"
                  @click="showConvertModal( quote.id )">
            Convert to basket
          </button>
        </div>
      </div>
      <div class="col-md-8 no-padding">
        <div class="quote-item__items">
          <div class="quote-item__heading">
            Products
          </div>

          <div v-if="quote.externalNotes"
               class="quote-item__notes">
            <p>
              {{ quote.externalNotes }}
            </p>
          </div>

          <div class="quote-item__items-list">
            <div class="row no-padding">
              <div v-for="(item, index) in quote.sopLines"
                   :key="index"
                   class="col-md-6 no-padding">
                <quote-item-product :name="item.productDisplayName"
                                    :quantity="item.quantity"
                                    :cost="item.priceExcVat">
                </quote-item-product>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { EcommerceModule } from "spiritweb.packages.ecommerce";
import QuoteItemProduct from "~/Components/Quotes/QuoteItemProduct.vue";

export default {
  name: "QuoteItem",
  components: {
    QuoteItemProduct
  },
  props: {
    quote: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    classes () {
      const result = [];

      if ( this.quote.statusId !== "ACT" ) {
        result.push( "quote-item--inactive" );
      }

      return result;
    }
  },
  methods: {
    formatDate ( input ) {
      return format( new Date( input ), "dd/MM/yyyy" );
    },
    formatPrice ( input ) {
      return EcommerceModule.renderPrice( input, "gbp", "en-gb" );
    },
    showConvertModal ( quoteId ) {
      this.$emit( "show-convert-modal", quoteId );
    }
  }
};
</script>

<style lang="less">
@border-colour: #B2D6D9;

.quote-item {
  position: relative;
  padding: 10px;
  margin: 10px 0;
  border: 2px solid @border-colour;
  background-color: #fff;
  font-size: 0.9rem;
  color: #333;

  &__summary {
    position: relative;
  }

  &__view-button {
    margin-top: 10px;
    @media screen and ( min-width: 768px ) {
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }

  &__categories {
    z-index: 100;
    padding: 10px;
    position: absolute;
    top: 0;
    right: 0;
  }

  &__items {
    @media screen and ( max-width: 768px ) {
      margin-top: 15px;
    }

    &-list {
      max-height: 325px;
      overflow-y: auto;
    }
  }

  &__heading {
    font-size: 1.25rem;
    font-weight: 700;
  }

  &__sub-heading {
    color: #999;
  }

  &__cost {
    color: red;
  }

  &__convert {
    margin-top: 10px;
  }

  .no-padding {
    padding: 0 !important;
    margin: 0 !important;
  }

  &--inactive {
    background: #f2f2f2;
  }
}
</style>
